<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="demandInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-demand-info :demandInfo="demandInfo" />
          <div style="margin-top: 10px" v-if="demandInfo.optCancel == 0">
            <el-button
              v-if="demandInfo.optStatus != 3 && demandInfo.optStatus != 4"
              :size="$xUISize"
              @click="editClick"
              type="default"
            >
              编辑
            </el-button>
            <el-button
              v-if="demandInfo.optPurchase != 2"
              :size="$xUISize"
              @click="purchaseClick"
              type="primary"
            >
              创建采购单
            </el-button>
          </div>
        </div>
      </el-card>
      <div>
        <x-tab
          v-model="tabName"
          :tabs="tabs"
          :query="tabParams"
          :params="tabParams"
          @call-event="onCallEvent"
        />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small">
        重新加载
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.demand-detail {
  margin-top: 20px;
}
</style>

<script>
import demandForm from './form.vue';
import demandPurchase from './_purchasse.vue';
import detailItemList from './__detail_item_list.vue';
import warehouseDemandInfo from '../../../../components/business/warehouseDemandInfo.vue';
import detailReplenishListPage from '../warehouse-replenish-list/__inner_replenish_list_store.vue';

export default {
  components: {
    warehouseDemandInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.demandInfo) {
        return {};
      }
      return {
        guid: this.demandInfo.guid,
        demandGuid: this.demandInfo.guid,
        storeGuid: this.demandInfo.storeGuid
      }
    },
    tabs() {
      if (!this.demandInfo) {
        return [];
      }
      let tabList = [
        {
          name: "demand-item-list",
          label: "要货清单",
          component: detailItemList,
          interval: true,
        },
      ]
      if (this.demandInfo.replenishInfoCount > 0) {
        tabList.push({
          name: "demand-replenish",
          label: "补货单记录",
          component: detailReplenishListPage,
          interval: true,
        })
      }
      return tabList;
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      demandInfo: null,
      printLoading: false,
      cancelLoading: false,
      tabName: ""
    }
  },
  methods: {
    onCallEvent(event) {
      if (event == "refresh") {
        this.$drawer.refreshDrawer();
        this.getDetail();
      }
    },
    editClick() {
      if (!this.demandInfo) {
        return;
      }
      this.$drawer.openDrawer({
        title: '编辑采购单',
        refresh: this.getDetail,
        component: demandForm,
        params: {
          guid: this.demandInfo.guid,
          storeGuid: this.demandInfo.storeGuid,
        },
      });
    },
    purchaseClick() {
      if (!this.demandInfo) {
        return;
      }
      this.$drawer.openDrawer({
        title: '创建采购单',
        refresh: this.getDetail,
        component: demandPurchase,
        params: {
          demandGuid: this.demandInfo.guid,
          storeGuid: this.demandInfo.storeGuid,
        },
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.demandInfo = null;
      return this.requestApi('biz.warehouse.demand.info.detail', {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
        storehouseGuid: this.pageParams.storehouseGuid
      }).then((resp) => {
        this.demandInfo = resp.data;
      }).catch((err) => {
        this.errorMsg = (err && err.msg) || (err && err.message)
          || '连接服务器失败，请检查网络';
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
}
</script>